import { defineComponent as _defineComponent } from 'vue'
import {getCurrentInstance, onMounted, reactive, ref} from 'vue';
import {Form, message} from "ant-design-vue";
import {getDetail, updateRule} from "@/api/tuan/rule";
import {loadList, paginationOption} from "@/util/page";
import {PaginationData} from "@/api/operation/customer";
import {TuanListData, getList, setInvalidX, setRemove} from "@/api/tuan/list";
import NEditor from "@/component/NForm/NEditor/NEditor.vue";
import router from "@/router";


// 设置相关

export default /*#__PURE__*/_defineComponent({
  __name: 'config',
  setup(__props) {

const setting = reactive({
  completion: false,
  foreshow: false,
  time: 30,
  rule: "",
});

onMounted(() => {
  initSetting();
})

async function initSetting() {
  getDetail().then((res) => {
    if (res.status == 200) {
      const data = res.data;
      setting.completion = data.open_completion == 1;
      setting.foreshow = data.open_foreshow == 1;
      setting.time = data.completion_minutes;
      setting.rule = data.rule;
      global.isLoading = false;
    }

  });
}

async function onUpdateSetting() {
  global.isLoading = true;
  updateRule({
    open_completion: setting.completion ? 1 : 0,
    open_foreshow: setting.foreshow ? 1 : 0,
    completion_minutes: setting.time,
    rule: setting.rule,
  }).then((res) => {
    global.isLoading = false;
    if (res.status == 200) {
      message.success("保存成功")
    } else {
      message.error(`保存失败: ${res.message}`)
    }
  });
}



// 列表相关
const listData = ref<PaginationData<any>>(loadList<TuanListData>());
const searchParams = ref();

onMounted(() => {
  getListData<TuanListData>(searchParams.value);
  searchParams.value = (Form as any)?.createForm(getCurrentInstance()?.proxy, {
    name: 'form',
  });
})

async function onSearch(e){
  e.preventDefault();
  searchParams.value.validateFields((err, values) => {
    if (!err) {
      getListData<TuanListData>(values);
      // queryListData<TuanListData>(values);
    }
  });
}

function clearForm() {
  searchParams.value=ref();
  getListData<TuanListData>(searchParams);
}

async function getListData<T>(searchParams: any) {
  const query_params = {
    ...searchParams,
    current: searchParams?.current || 1,
  };

  global.tableloading = true;
  listData.value = {...listData.value, detail: []}
  const res: any = await getList(query_params);
  global.tableloading = false;

  if (res.status !== 200) {
    message.error(res.message);
    return;
  }


  listData.value = {...listData.value, detail: res.data.detail}
}



const global = reactive({
  activeKey: "1",
  isLoading: true,
  tableloading: true,
});

const statusList = [
  {
    id: 1,
    title: "未开始"
  },
  {
    id: 2,
    title: "已失效"
  },
  {
    id: 3,
    title: "进行中"
  },
  {
    id: 4,
    title: "已结束"
  },
];



function onAdd(){
  router.push("/marketing/together/add");
}

function onEdit(id){
  router.push(`/marketing/together/edit?id=${id}`);
}
async function onRemove(id){
  const res = await setRemove(id);
  if(res)
    getListData<TuanListData>(searchParams);
}
function onView(id){
  router.push(`/marketing/together/view?id=${id}&readonly=1`);
}

async function onInvalid(id){
  const res = await setInvalidX(id);
  if(res)
    getListData<TuanListData>(searchParams);
}


return { __sfc: true,setting, initSetting, onUpdateSetting, listData, searchParams, onSearch, clearForm, getListData, global, statusList, onAdd, onEdit, onRemove, onView, onInvalid, paginationOption, NEditor }
}

})